<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="margin-top-card pfCard">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
          <v-card-text>
            <v-container>
              <h2>Register with us</h2>
              <v-form>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="firstName"
                      label="First Name"
                      id="firstName"
                      v-model="firstName"
                      :error-messages="errors.collect('firstName')"
                      v-validate="'required|min:2|max:30'"
                      data-vv-name="firstName"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="lastName"
                      label="Last Name"
                      id="lastName"
                      v-model="lastName"
                      :error-messages="errors.collect('lastName')"
                      v-validate="'required|min:2|max:30'"
                      data-vv-name="lastName"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      label="Email Address"
                      id="email"
                      v-model="email"
                      :error-messages="errors.collect('email')"
                      v-validate="'required|email'"
                      data-vv-name="email"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      v-validate="'required|min:8'"
                      :error-messages="errors.collect('password')"
                      data-vv-name="password"
                      type="password"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="confirmPassword"
                      label="Confirm Password"
                      id="confirmPassword"
                      v-model="confirmPassword"
                      v-validate="'required|confirmed:password'"
                      :error-messages="errors.collect('confirmPassword')"
                      data-vv-as="password"
                      type="password"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="telephone"
                      label="Telephone"
                      id="telephone"
                      v-model="telephone"
                      v-validate="'required|max:30'"
                      :error-messages="errors.collect('telephone')"
                      data-vv-name="telephone"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="address1"
                      label="Address Line 1"
                      id="address1"
                      v-model="address1"
                      v-validate="'required|max:30'"
                      :error-messages="errors.collect('address1')"
                      data-vv-name="address1"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="address2"
                      label="Address Line 2"
                      id="address2"
                      v-model="address2"
                      v-validate="'required|max:30'"
                      :error-messages="errors.collect('address2')"
                      data-vv-name="address2"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="town"
                      label="Town/City"
                      id="town"
                      v-model="town"
                      v-validate="'required|max:30'"
                      :error-messages="errors.collect('town')"
                      data-vv-name="town"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="county"
                      label="County"
                      id="county"
                      v-model="county"
                      v-validate="'required|max:30'"
                      :error-messages="errors.collect('county')"
                      data-vv-name="county"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="postcode"
                      label="Postcode"
                      id="postcode"
                      v-model="postcode"
                      v-validate="'required|max:30'"  
                      :error-messages="errors.collect('postcode')"
                      data-vv-name="postcode"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <div class="text-xs-center">
                    <v-btn color="primary" @click="onSignup" ripple :disabled="loading" v-if="!loading">
                      Sign up
                    </v-btn>
                                        <br><br>
                      <p><router-link to="/">Already have and account?</router-link></p>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import shared from '../../mixins/shared'

export default {
  mixin: [shared],
  $_veeValidate: {
    validator: 'new'
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  data () {
    return {
      loading: false,
      valid: true,
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      telephone: '',
      address1: '',
      address2: '',
      town: '',
      county: '',
      postcode: '',
      dictionary: {
        attributes: {
          email: 'E-mail Address'
        }
      }
    }
  },
  computed: {
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : ''
    },
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/issue-type')
      }
    }
  },
  methods: {
    onSignup () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          this.$fb.auth().createUserWithEmailAndPassword(this.email, this.password).then(user => {
            const newUser = {
              firstName: this.firstName,
              lastName: this.lastName,
              telephone: this.telephone,
              address1: this.address1,
              address2: this.address2,
              town: this.town,
              county: this.county,
              postcode: this.postcode,
              email: user.email,
              approved: true,
              role: 'User'
            }
            this.$db.collection('userMeta').doc(user.uid).set(newUser).catch(error => {
              this.addNotification({text: error.message, color: 'error'})
              this.loading = false
              console.log(error)
            })
            this.loading = false
            this.$store.dispatch('signUserUp', newUser)
          }).catch(error => {
            this.addNotification({text: error.message, color: 'error'})
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
<style>
@media only screen and (max-width : 800px) {
  .pfCard.v-card {
    background-color: transparent;
    padding:  0;
    box-shadow: none
  }
  .pfCard .v-card__text {
    padding:  0;
  }
}

.logo {
  height: 45px;
  width: auto;
}
.logo-span {
  display: inline-flex;
  -webkit-box-align: center;
-ms-flex-align: center;
align-items: center;
-webkit-box-pack: center;
-ms-flex-pack: center;
justify-content: center;
position: relative;
text-align: center;
vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// Signup.vue?92972698